export interface IIxTreeNode {
  children?: Array<IIxTreeNode>;

  expanded?: boolean;

  icon?: string;

  id: string;

  label: string;

  parentId?: string;

  checked?: boolean;

  indeterminate?: boolean;

  disabled?: boolean;

  fixed?: boolean;
}
